import React from 'react';
import emptyStateImage from '../app/webcomponents/assets/images/empty-states_illustration_success.svg';
import '../assets/css/NotFound.css';

function NotFound() {
  return (
    <div className='flex flex-col items-center justify-center center-div'>
      <img width={200} height={171} src={emptyStateImage} alt="404 - This page doesn't exist" />
      <h2 className='pb-3 mt-2 font-semibold' >404 - Page not found</h2>
    </div>
  )
}

export default NotFound;